import {
	useQuery,
	useInfiniteQuery,
	useQueryClient,
	useMutation,
} from "react-query";
import { toast } from "react-toastify";
import API from "./utils/api";
import {
	AllowanceDto,
	AllowancePaginator,
	CreateAllowanceDto,
	QueryAllowanceDto,
	SearchAllownaceDto,
	UpdateAllowanceDto,
} from "../models/allowance.dto";
import ENDPOINTS from "./utils/endpoints";

export function useGetAllowance(options?: QueryAllowanceDto) {
	const url = ENDPOINTS.PROCESSING_COMPANY.ALLOWANCE.GET;
	const request = (options: QueryAllowanceDto) =>
		API.ProcessingCompanyAPI.getAllowance(options);

	const { data, isLoading, error, refetch } = useQuery<
		AllowancePaginator,
		Error
	>(
		[url, options],
		({ queryKey, pageParam }) =>
			request(Object.assign({}, queryKey[1], pageParam)),
		{ ...API.Handlers.pageParamOption }
	);

	return { data, isLoading, error, refetch };
}

export function useGetAllowanceSearch() {
	return useMutation(
		(options?: SearchAllownaceDto) =>
			API.ProcessingCompanyAPI.getAllowanceSearch(options),
		{
			onSuccess: () => {
				//toast.success('Record created successfully');
			},
			onError: API.Handlers.onErrorHandler,
		}
	);
}

export function useGetAllowanceById(id: number) {
	const url = ENDPOINTS.PROCESSING_COMPANY.ALLOWANCE.DETAIL;
	const request = API.ProcessingCompanyAPI.getAllowanceById(id);

	const { data, isLoading, error } = useQuery<{ data: AllowanceDto }, Error>(
		[url, id],
		() => request,
		{
			enabled: !!id,
		}
	);

	return {
		data: data,
		isLoading,
		error,
	};
}
export function useCreateAllowance() {
	const queryClient = useQueryClient();

	return useMutation(
		({ payload }: { payload: CreateAllowanceDto }) =>
			API.ProcessingCompanyAPI.createAllowance(payload),
		{
			onSuccess: () => {
				toast.success("Record created successfully");
				queryClient.invalidateQueries(
					ENDPOINTS.PROCESSING_COMPANY.ALLOWANCE.GET
				);
			},
			onError: API.Handlers.onErrorHandler,
		}
	);
}

export function useUpdateAllowance() {
	const queryClient = useQueryClient();

	return useMutation(
		({ payload, id }: { payload: UpdateAllowanceDto; id: number }) =>
			API.ProcessingCompanyAPI.updateAllowance(id, payload),
		{
			onSuccess: () => {
				toast.success("Record updated successfully");
				queryClient.invalidateQueries(
					ENDPOINTS.PROCESSING_COMPANY.ALLOWANCE.GET
				);
			},
			onError: API.Handlers.onErrorHandler,
		}
	);
}

export function useDeleteAllowance() {
	return useMutation(
		({ id }: { id: number }) => API.ProcessingCompanyAPI.deleteAllowance(id),
		{
			onSuccess: () => {
				toast.success("Record deleted successfully");
			},
			onError: API.Handlers.onErrorHandler,
		}
	);
}

export function useGetAllowanceByCode(companyId: number, code: string) {
	const url = ENDPOINTS.PROCESSING_COMPANY.ALLOWANCE.GET_BY_CODE;
	const request = API.ProcessingCompanyAPI.getAllowanceByCode(companyId, code);

	const { data, isLoading, error } = useQuery<{ data: AllowanceDto }, Error>(
		[url, code],
		() => request,
		{
			enabled: !!code,
		}
	);

	return {
		data: data,
		isLoading,
		error,
	};
}

export function useUploadAllowance() {
	return useMutation(
		({ payload, companyId }: { payload: FormData; companyId: number }) =>
			API.ProcessingCompanyAPI.uploadAllowance(companyId, payload),
		{
			onSuccess: () => {},
			onError: API.Handlers.onErrorHandler,
			onSettled: () => {},
		}
	);
}
